import services from './services';
import operateAddressDialog from 'operateAddressDialog';
// import editdialog from './component/editdialog/index.vue'//编辑代理区域
import agentInfo from '../../../components/agent-infonew';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

import optContractStatus from '@pages/CRMFormatAgent/components/optContractStatus';
import viewContractStatusListDialog from '@pages/CRMFormatAgent/components/viewContractStatusListDialog';
import $http from '$http';

export default {
    components: {
        'agent-info': agentInfo,
        operateAddressDialog,
        optContractStatus,
        viewContractStatusListDialog
    },
    mixins: [services],
    data() {
        return {
            settings: this.getSettings(),
            onlyLookAgentInfo: false,
            activeName: 'tab1',
            ChoicePolicyList: this.$store.state.ChoicePolicyList,
            addAgentList: [],
            addVisible: false,
            addDialogCallback: false,
            submitBtn: false,
            AreaList: [],
            editData: {},
            editVisible: false,
            editVisibleList: false,
            agentList: [],
            choiceAgentInfoIndex: '',
            agentDeliveryAddress: {},
            agentAreaId: "",
            CustomerId: "",
            AgentId: "",
            htztList: [],
            choiceAgentInfo: null,
            isPerson: false
        }
    },
    props: {
        isUpdate: {
            default () {
                return true;
            }
        }
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    watch: {},
    methods: {
        getPolicyName(value) {
            if (value == 0) {
                return "--";
            }
            return util.getItemByIdInArr(value, this.ChoicePolicyList, 'key').value;
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        showAddAreaDialog() {
            this.addVisible = true;
            this.addAgentList.push({});
        },
        getSettings() {
            return cloneDeep({
                isReadOnly: false,
                AgentId: "",
                CustomerId: ""
            });
        },
        show(optons) {
            let opts = Object.assign({}, this.getSettings(), optons);
            this.settings = opts;
            this.editVisibleList = true;
            this.$nextTick(() => {
                this.AgentId = opts.AgentId;
                this.CustomerId = opts.CustomerId;
                this.req_getAreaList();
                this.getHtList();
            });
        },
        //显示编辑模块的修改地址窗口
        showChoicedAddressDiaolog(agentInfoIndex) {
            this.choiceAgentInfo = this.$refs['agentInfo' + agentInfoIndex][0];
            this.comShowOperateAddressDialogByAgentData(this.choiceAgentInfo.getAreaDetails());
        },
        //显示添加模块的修改地址窗口
        showAddAgentChoicedAddressDiaolog(agentInfoIndex) {
            this.choiceAgentInfo = this.$refs['addAgentInfo' + agentInfoIndex][0];
            //this.choiceAgentInfo.isLevel 为true时，则是智趣坞下的体验级别，isLimitArea==false
            this.comShowOperateAddressDialogByAgentData(this.choiceAgentInfo.getAreaDetails());

        },
        comShowOperateAddressDialogByAgentData(agentData) {
            //this.choiceAgentInfo.isLevel 为true时，则是智趣坞下的体验级别，isLimitArea==false
            console.log(this.choiceAgentInfo.isLevel)
            if (this.choiceAgentInfo.isLevel) {
                this.isLimitArea = false
                this.showOperateAddressDialog({
                    "ProvId": '',
                    "CityId": '',
                    "AreaId": '',
                    provName: '',
                    cityName: '',
                    areaName: ''
                });
            } else {
                this.isLimitArea = true
                if ($.trim(agentData._provName).length == 0 || $.trim(agentData._cityName).length == 0) {
                    return;
                }
                this.showOperateAddressDialog({
                    "ProvId": agentData.ProvId,
                    "CityId": agentData.CityId,
                    "AreaId": agentData.AreaId,
                    provName: agentData._provName,
                    cityName: agentData._cityName,
                    areaName: agentData._areaName
                });
            }



        },
        showOperateAddressDialog(options) {
            //新增智趣坞下的体验级别，收货地址不做省市的限制
            let opts = Object.assign({}, {
                isLimitArea: false, //限制省市选择，为true时候，选择收货地址里的省市不能选
                "ProvId": "",
                "CityId": "",
                "AreaId": "",
                provName: "",
                cityName: "",
                areaName: "",
                CustomerId: this.CustomerId
            }, options);
            this.$nextTick(() => {
                this.$refs.refOperateAddressDialog.show(opts);
            });
        },
        selectAddress(params) {
            this.choiceAgentInfo.refSetDeliveryAddress(params);
        },
        //---------顶上为地址收货信息-----
        closedialog() {},
        dgclosecallback() {
            this.activeName = "tab1";
            this.settings = this.getSettings();
        },
        delAgentfn(item) {
            this.agentList.splice((item.index - 1), 1);
        },
        callback() {
            this.agentList = [];
            this.onlyLookAgentInfo = false;
        },
        addDgCallback() {
            this.addAgentList = [];
        },
        // 修改代理商区域
        submitFn() {
            this.updateAgentArea();
        },
        viewHztByAreaId(id) {
            this.onlyLookAgentInfo = true;
            //this.req_getOneData(Id, AgentAreaId);
        },
        req_getOneDataFn(row) {
            this.req_getOneData(this.CustomerId, row.Id);
        },
        viewHtztByAreaId(item) {
            this.$refs.refviewContractStatusListDialog.show({
                isReadOnly: true,
                AreaId: item.Id
            });
        },
        addNewHtzt() {
            this.$refs.refoptContractStatus.show({
                AgentId: this.AgentId,
                isAdd: true
            });
        },
        viewHtzt(item) {

            this.$refs.refviewContractStatusListDialog.show({
                ContractId: item.Id,
                isReadOnly: true
            });

        },
        delHtzt(item) {

            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    Id: item.Id
                };

                //GET /api/Agent/DelAreaContractById
                $http.get('api/Agent/DelAreaContractById', params).then(res => {
                    let {
                        Data
                    } = res.data;
                    util.doResult(this, res, () => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.reloadZtList();
                    });
                });

            }).catch(() => {

            });
        },
        reloadZtList() {
            this.getHtList();
            this.req_getAreaList();
        }
    },
    mounted() {

    },
    created() {

    }
}


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/agentArea/vm.js